import { defineStore } from "pinia"

const useMessageStore = defineStore(
  'message',
  {
    state: () => ({
      messageCounts: {
        alert: 0,        // 告警数量（未读）
        task: 0,         // 待办数量（未读）
        reminder: 0,     // 提醒数量（未读）
        notification: 0  // 通知数量（未读）
      },
      shouldOpenChatBox: false // 是否应该打开聊天框（从AI页面退出时使用）
    }),
    actions: {
      // 设置消息数量
      setMessageCounts(counts) {
        this.messageCounts = {
          alert: counts.alert || 0,
          task: counts.task || 0,
          reminder: counts.reminder || 0,
          notification: counts.notification || 0
        }
      },
      // 设置是否应该打开聊天框
      setShouldOpenChatBox(shouldOpen) {
        this.shouldOpenChatBox = shouldOpen
      }
    },
    // 启用持久化，刷新后数据不丢失
    persist: {
      enabled: true,
      strategies: [
        {
          key: 'message-store',
          storage: sessionStorage // 使用 sessionStorage，关闭标签页后清除
        }
      ]
    }
  }
)

export default useMessageStore

